/**
 * The closed vocabularies for the `Click Download` Mixpanel event. They live here rather than beside
 * any one caller because the event fires from three services — marketing, the web app's top-strip
 * banners, and the login pages' banner and shared-note preview — and a funnel that compares
 * in-product upsell against marketing traffic only works if all of them spell the surfaces the same.
 */

/** The `Event Source` property: which acquisition surface the download click came from. */
export type DownloadEventSource =
  | 'Downloads Page'
  | 'Meetings Page'
  | 'Android Page'
  | 'Header'
  | 'Footer'
  | 'Web App Banner'
  | 'Web App iPad Banner'
  | 'Login Banner'
  | 'Shared Note Preview'

/**
 * The `Download Platform` property. The universal App Store listing serves both iPad and iPhone, so
 * all Apple-mobile downloads report a single `iOS`.
 */
export type DownloadPlatform = 'Mac' | 'Windows' | 'iOS' | 'Android'
